/* eslint-disable */
import {
  BufferGeometry,
  Material,
  Camera,
  Object3D,
  AxesHelper,
  BoxGeometry,
  BoxHelper,
  Clock,
  Color,
  DoubleSide,
  Euler,
  Group,
  Intersection,
  IUniform,
  MathUtils,
  Mesh,
  MeshBasicMaterial,
  MeshStandardMaterial,
  NormalBlending,
  OrthographicCamera,
  PerspectiveCamera,
  Points,
  Quaternion,
  Raycaster,
  Scene,
  ShaderMaterial,
  Texture,
  Vector2,
  Vector3,
  WebGLRenderer,
  AnimationMixer,
  AnimationClip,
  LoopOnce,
  AnimationAction,
} from 'three';
import { useLoadStore } from '../stores/use-load-store';

class BaseScene {
  needRotate = false;
  renderer!: WebGLRenderer;
  scene!: Scene;
  camera!: PerspectiveCamera | OrthographicCamera;

  size: Vector2 = new Vector2();
  pixelRatio = window.devicePixelRatio > 2 ? 2 : window.devicePixelRatio;

  get width() {
    return this.size.x;
  }

  get height() {
    return this.size.y;
  }
  constructor(renderer: WebGLRenderer) {
    this.renderer = renderer;
    this.renderer.getSize(this.size);
    this.pixelRatio = this.renderer.getPixelRatio();
  }

  getScreenPos(t: { pageX: number; pageY: number }) {
    const currentTouch = new Vector2();
    if (this.needRotate) {
      currentTouch.x = t.pageY;
      currentTouch.y = this.height - t.pageX;
    } else {
      currentTouch.x = t.pageX;
      currentTouch.y = t.pageY;
    }
    return currentTouch;
  }

  screenPosToUv(pos: Vector2) {
    let res = pos.clone().divide(new Vector2(this.width, this.height));
    res.y = 1 - res.y;
    return res;
  }
  onWindowResize() {
    this.renderer.getSize(this.size);
    this.pixelRatio = this.renderer.getPixelRatio();
  }
  onTouchStart(e: TouchEvent) {}

  onTouchMove(e: TouchEvent) {}

  onTouchEnd(e: TouchEvent) {}

  onMouseDown(e: MouseEvent) {}

  onMouseMove(e: MouseEvent) {}

  onMouseUp(e: MouseEvent) {}

  onClick(e: MouseEvent) {}
  onWheel(e: WheelEvent) {}

  reset() {}
  anim(t: number, delta: number) {}

  updateProgress(id: string, progress: number) {
    const updateProgress = useLoadStore.getState().updateProgress;
    updateProgress(id, progress);
  }

  mats: Material[] = [];
  texs: Texture[] = [];
  geos: BufferGeometry[] = [];

  dispose() {
    try {
      this.geos.forEach(g => g?.dispose());
      this.mats.forEach(m => m?.dispose());
      this.texs.forEach(t => t?.dispose());
    } catch (err) {
      console.log('Error when dispose');
    }
  }
}

export default BaseScene;
